import { render, staticRenderFns } from "./TransportadoraModal.vue?vue&type=template&id=6f67514e&scoped=true"
import script from "./TransportadoraModal.vue?vue&type=script&lang=js"
export * from "./TransportadoraModal.vue?vue&type=script&lang=js"
import style0 from "./TransportadoraModal.vue?vue&type=style&index=0&id=6f67514e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f67514e",
  null
  
)

export default component.exports